/**
 * SectionLabel — seksjonsoverskriften på Oppgaver og Lekser (#154): 12 px,
 * 700, store bokstaver med litt sperring, ink-2 (skissens `lbl`).
 *
 * Fullfør- og Foreslå-arkene (steg 4c) bruker samme stil på feltetikettene,
 * så `as` kan også være `label` (med `htmlFor`) eller `span`. Oppsett (#159,
 * steg 9f) bruker `legend` for gruppene i et `<fieldset>`.
 */
import type { ReactNode } from 'react';

interface SectionLabelProps {
  id?: string;
  /** h2 for seksjoner, h3 for grupper inne i en seksjon, label/span for felt, legend i fieldset. */
  as?: 'h2' | 'h3' | 'label' | 'span' | 'legend';
  htmlFor?: string;
  /** Uten bunnmarg, når etiketten står på rad med en knapp (#159, steg 9e). */
  flush?: boolean;
  children: ReactNode;
  'data-testid'?: string;
}

export function SectionLabel({
  id,
  as: Tag = 'h2',
  htmlFor,
  flush = false,
  children,
  'data-testid': testId,
}: SectionLabelProps): ReactNode {
  return (
    <Tag
      id={id}
      htmlFor={Tag === 'label' ? htmlFor : undefined}
      data-testid={testId}
      className={`m-0 block text-caption font-bold tracking-wider text-ink-2 uppercase ${flush ? '' : 'mb-2.5'}`}
    >
      {children}
    </Tag>
  );
}
